import i18n from 'i18next';
import get from 'lodash/get';
import identity from 'lodash/identity';
import isEqual from 'lodash/isEqual';
import pickBy from 'lodash/pickBy';
import moment from 'moment';
import numeral from 'numeral';

import {authentication} from '@/settings';

export const formatNumber = (price, format = '0,0.00') => {
  return numeral(price).format(format);
};

export const showPrice = (price, currency = '$', format = '0,0.00') => {
  return price ? `${currency} ${formatNumber(price, format)}` : '';
};

export const showNomenclature = (value, nomenclature = 'h') => {
  return value ? `${formatNumber(value, '0')} ${nomenclature}` : '';
};

export const scrollToPosition = (value = 0) => {
  document.body.scrollTop = value; // For Safari
  document.documentElement.scrollTop = value;
};

export const getFileName = (value) => {
  if (!value) return '';
  const paths = value.split('/');
  return paths[paths.length - 1];
};

export const showCard = (value) => {
  return '**** **** **** ' + value.substr(-4);
};

export const getSelectedKeys = (data) => {
  const obj = Object.keys(data);
  return obj.filter((key) => data[key].selected && key);
};

export const getNameInitial = (name) => {
  const rgx = new RegExp(/(\p{L}{1})\p{L}+/, 'gu');

  let initials = [...name.matchAll(rgx)] || [];

  initials = (
    (initials.shift()?.[1] || '') + (initials.pop()?.[1] || '')
  ).toUpperCase();

  return initials;
};

export const getBirthDate = (idNumber, today = moment()) => {
  if (!idNumber) return 0;

  const strDate = idNumber.substr(0, 7);
  // eslint-disable-next-line radix
  let year = parseInt(strDate.substr(0, 2));
  // eslint-disable-next-line radix
  const month = parseInt(strDate.substr(2, 2));
  // eslint-disable-next-line radix
  const day = parseInt(strDate.substr(4, 2));
  // eslint-disable-next-line radix
  const century = parseInt(strDate.substr(6, 1));

  const between = (n, a, b) => (((a === n) && (b === n)) ? true : (n - a) * (n - b) <= 0);

  if (between(century, 0, 5)) {
    year += 1900;
  } else if (between(century, 6, 8)) {
    year += 2000;
  }

  const birthDate = moment({year, month: month - 1, day}); // month are 0-11
  return today.diff(birthDate, 'years');
};

export const isMinor = () => ({
  validator(rule, value) {
    if (value) {
      const age = getBirthDate(value);
      if (age < 18)
        return Promise.reject(i18n.t('idNumberBelow'));
      return Promise.resolve();
    }
    return Promise.resolve();
  },
});

export const isIdNumberEqual = (toMatch) => ({
  validator(rule, value) {
    if (value) {
      if (value && toMatch && value === toMatch)
        return Promise.reject(i18n.t('idNumberIsEqual'));
      return Promise.resolve();
    }
    return Promise.resolve();
  },
});

export const isEqualObjects = (obj1, obj2) => {
  const res1 = pickBy(obj1, identity);
  const res2 = pickBy(obj2, identity);
  return isEqual(res1, res2);
};

export const getModelDocDownloadUrl = (key) => {
  return `${process.env.REACT_APP_BACKEND_URL}${authentication.path}/api/proposal-requests/download/${key}`;
};

export const percentFormat = (count, total, maximumFractionDigits = 2) => {
  return (count / (total || 1)).toLocaleString('en', {style: 'percent', maximumFractionDigits});
};

export const transformKeyToObject = (values, processList) => {
  if (!values) return {};
  return Object.keys(values)
    ?.filter((e) => processList ? processList.includes(e) : true)
    ?.reduce((result, key) => {
      result = {...result, ...values?.[key] || {}};
      return result;
    }, {});
};

export const getOrElse = (object, path1, path2) => {
  return get(object, path1) || get(object, path2);
};
